import createLiveChatTicket from './createLiveChatTicket';

export default createLiveChatTicket;
